<script lang="ts">
  import * as Dialog from "$lib/components/ui/dialog/index.js";
  import { Button, buttonVariants } from "$lib/components/ui/button/index.js";
  import { t } from "svelte-i18n";
  import { ScrollArea } from "$lib/components/ui/scroll-area/index.js";
  import { Files } from "lucide-svelte";
  import * as Tooltip from "$lib/components/ui/tooltip/index.js";

  let isOpen: boolean = false;
</script>

<Dialog.Root bind:open={isOpen}>
  <Dialog.Trigger>
    <Tooltip.Root>
      <Tooltip.Trigger asChild let:builder>
        <Button builders={[builder]} variant="secondary" size="sm">
          <Files class="h-4 w-4" />
        </Button>
      </Tooltip.Trigger>
      <Tooltip.Content>
        <p>{$t("page.projects.detail.copyProject")}</p>
      </Tooltip.Content>
    </Tooltip.Root>
  </Dialog.Trigger>
  <Dialog.Content
    class="flex flex-col h-dvh sm:h-[650px] sm:my-auto overflow-hidden sm:max-h-dvh"
  >
    <Dialog.Header>
      <Dialog.Title>{$t("page.customers.new.title")}</Dialog.Title>
    </Dialog.Header>
    <div class="flex flex-col flex-grow h-full overflow-hidden">
      <ScrollArea orientation="vertical">
        <div class="grid w-full h-full grid-cols-2 gap-2 max-w-md p-2"></div>
      </ScrollArea>
    </div>
    <Dialog.Footer class="flex pt-4">
      <Button type="submit" class="px-8">
        {$t("global.messages.create")}
      </Button>
    </Dialog.Footer>
  </Dialog.Content>
</Dialog.Root>
